import useAlertStore from "store/alert";
import {
  useUpdateCntApi,
  useUpdatePriceApi,
  useUpdateStatusApi,
} from "./service";
import { useCalendarCardInfContext } from "../context";
import { priceFormat } from "components/utils/comm";
import i18n from "locales/i18n";
import { langProps } from "interface/index";
import useLodStore from "store/lod";
import { rmPdCtProps } from "interface/rm/crr";

// 상품상태 변경
export const useUpdateStatus = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { cardInf } = useCalendarCardInfContext();
  const { mutate } = useUpdateStatusApi();
  const onUpdateStatus = () => {
    onSetAlert({
      isOpen: true,
      inner: "상품상태를 변경하시겠습니까?",
      cnclBtn: true,
      onSetConfirm: () => {
        const params = {
          rmNo: cardInf?.rmNo ?? "",
          sellDt: cardInf?.sellDt ?? "",
          sellYn: cardInf?.sellStaCd === "S01" ? "Y" : "N",
          tarSellYn: cardInf?.sellStaCd === "S01" ? "N" : "Y",
          opRgSeq: cardInf?.opRgSeq ?? 0,
        };
        mutate(params);
      },
    });
  };

  return {
    onUpdateStatus,
  };
};

// 상품가격 변경
export const useUpdatePrice = () => {
  const langCd = i18n.language;
  const { cardInf } = useCalendarCardInfContext();
  const { mutate } = useUpdatePriceApi();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);

  const onUpdatePrice = (sellPri: string) => {
    const txt = {
      ko: `상품가격을  ${priceFormat({
        price: cardInf?.sellPri ?? "",
        payLangCd: "none",
      })} 
      에서 ${sellPri} 로 변경하시겠습니까?`,
      en: "",
    };
    if (!sellPri) {
      return onSetAlert({
        isOpen: true,
        inner: "변경할 가격을 입력하여 주세요",
      });
    }
    if (!!sellPri && cardInf) {
      // 가격 변경 api
      const params = {
        rmNo: cardInf?.rmNo,
        opRgSeq: cardInf?.opRgSeq,
        sellDt: cardInf?.sellDt ?? "",
        sellPri: sellPri.replaceAll(",", ""),
      };
      onSetAlert({
        isOpen: true,
        inner: txt[langCd as keyof langProps],
        cnclBtn: true,
        onSetConfirm: () => {
          mutate(params);
        },
      });
    }
  };

  return {
    onUpdatePrice,
  };
};

// 상품 수량변경
export const useUpdateCnt = () => {
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate } = useUpdateCntApi();
  const { cardInf } = useCalendarCardInfContext();
  const lod = useLodStore((state) => state.lod);
  const langCd = i18n.language;
  const onUpdateCnt = (rmCt: number | string) => {
    const txt = {
      ko: `현재 상품수량을 ${cardInf?.sellCt}개에서 ${rmCt}개로 변경하시겠습니까?`,
      en: "",
    };
    if (!rmCt) {
      return onSetAlert({
        isOpen: true,
        inner: "변경하려는 상품 수량을 입력하여 주세요.",
      });
    }
    if (!!rmCt) {
      // 상품 수량 변경
      const params = {
        lodNo: lod?.lodNo ?? "",
        lodChlCd: cardInf?.lodChlCd,
        rmNo: cardInf?.rmNo,
        sellDt: cardInf?.sellDt,
        opRgSeq: cardInf?.opRgSeq,
        rmCt,
      } as rmPdCtProps;
      onSetAlert({
        isOpen: true,
        inner: txt[langCd as keyof langProps],
        cnclBtn: true,
        onSetConfirm: () => {
          // api통신
          mutate(params);
        },
      });
    }
  };

  return {
    onUpdateCnt,
  };
};
